define(
    'models/reputation.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var ReputationModel = Loader.Backbone.Model.extend({

            defaults: {},

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');
            },

            getReputation: function(list, successCallback, errorCallback)
            {
                Sandbox.transport.send(Config.transport.channels.getReputation, {
                        "board_id": this.model.get('forum').get('boardId'),
                        "reputations": list
                    },
                    function(result){
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    }
                );
            },

            sendReputation: function(obj, successCallback, errorCallback)
            {
                Sandbox.transport.send(Config.transport.channels.sendReputation, {
                        "board_id": this.model.get('forum').get('boardId'),
                        "reputation": {
                            "from_id": this.model.get('users').getMe().get('id'),
                            "to_id": obj.userId,
                            "post_id": obj.postId,
                            "topic_name": obj.topicName,
                            "type": obj.type,
                            "message": obj.message
                        }
                    },
                    function(result){
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    },
                    true
                );
            },

            removeReputation: function(data, successCallback, errorCallback)
            {
                Sandbox.transport.send(Config.transport.channels.removeReputation, _.extend({
                        "board_id": this.model.get('forum').get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id')
                    }, data),
                    function(result){
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    },
                    true
                );
            },

            editReputation: function(data, successCallback, errorCallback)
            {
                Sandbox.transport.send(Config.transport.channels.editReputation, _.extend({
                        "board_id": this.model.get('forum').get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id')
                    }, data),
                    function(result){
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    },
                    true
                );
            }

        });

        return {
            initialize: function(model)
            {
                return new ReputationModel({
                    model: model
                })
            }
        }
    }
);

